// extracted by mini-css-extract-plugin
module.exports = {"expired-banner":"LicenseValidator_expired-banner__5QgQn","icon":"LicenseValidator_icon__2vq4B"};